(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artshop-idea-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('artshop-idea-slider')) {
    customElements.define('artshop-idea-slider', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          this.readyHandler = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        } else this.initialize();
      }

      initialize() {
        if (this.events) return;
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.controls = this.querySelector('[data-controls]');
        if (!this.viewport || this.slides.length < 2 || !this.controls) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.pendingIndex = null;
        this.hovered = false;
        this.visible = false;
        this.manualScroll = false;
        this.interval = Math.max(3000, (Number(this.dataset.interval) || 6) * 1000);
        this.paused = this.dataset.autoplay !== 'true' || this.dataset.editor === 'true' || this.motion.matches;
        this.rotation = this.querySelector('[data-rotation]');
        this.status = this.querySelector('[data-status]');
        this.dots = [...this.querySelectorAll('[data-slide-to]')];
        this.controls.hidden = false;
        this.rotation.addEventListener('pointerdown', () => {
          this.rotationPointerPaused = this.paused;
        }, options);
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-rotation')) {
            this.paused = this.rotationPointerPaused === undefined ? !this.paused : !this.rotationPointerPaused;
            this.rotationPointerPaused = undefined;
            this.sync();
            this.schedule();
          } else if (button.hasAttribute('data-previous')) {
            this.goTo((this.pendingIndex ?? this.index) - 1);
          } else if (button.hasAttribute('data-next')) {
            this.goTo((this.pendingIndex ?? this.index) + 1);
          } else if (button.hasAttribute('data-slide-to')) {
            this.goTo(Number(button.dataset.slideTo));
          }
        }, options);
        this.viewport.addEventListener('pointerdown', () => {
          this.manualScroll = true;
          this.pause();
        }, options);
        this.viewport.addEventListener('scroll', () => {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.finishScroll(), 140);
        }, { ...options, passive: true });
        this.viewport.addEventListener('scrollend', () => this.finishScroll(), options);
        this.addEventListener('keydown', event => {
          if (event.target.closest('a') || event.altKey || event.ctrlKey || event.metaKey) return;
          const current = this.pendingIndex ?? this.index;
          const targets = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          this.goTo(targets[event.key]);
        }, options);
        this.addEventListener('focusin', () => this.pause(), options);
        this.addEventListener('mouseenter', () => {
          this.hovered = true;
          clearTimeout(this.timer);
        }, options);
        this.addEventListener('mouseleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.pause();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === String(event.detail.blockId));
          if (selected >= 0) this.goTo(selected, true, true);
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (event.target.contains(this)) this.pause();
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          this.viewport.scrollTo({ left: this.index * this.viewport.clientWidth, behavior: 'auto' });
        });
        this.resizeObserver.observe(this.viewport);
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
          this.schedule();
        }, { threshold: .2 });
        this.visibilityObserver.observe(this);
        this.sync();
      }

      pause() {
        this.paused = true;
        clearTimeout(this.timer);
        this.sync();
      }

      sync() {
        this.slides.forEach((slide, index) => {
          slide.inert = index !== this.index;
          slide.setAttribute('aria-hidden', String(index !== this.index));
        });
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.rotation.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
        this.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.paused || this.hovered || !this.visible || document.hidden) return;
        this.timer = setTimeout(() => this.goTo(this.index + 1, false), this.interval);
      }

      goTo(index, manual = true, instant = false) {
        clearTimeout(this.timer);
        this.pendingIndex = (index + this.slides.length) % this.slides.length;
        this.manualScroll = manual;
        if (manual) this.pause();
        const image = this.slides[this.pendingIndex].querySelector('img');
        if (image) image.loading = 'eager';
        this.viewport.scrollTo({
          left: this.pendingIndex * this.viewport.clientWidth,
          behavior: instant || this.motion.matches ? 'auto' : 'smooth'
        });
        if (instant || this.motion.matches || this.pendingIndex === this.index) this.finishScroll();
      }

      finishScroll() {
        clearTimeout(this.settleTimer);
        if (!this.events || !this.viewport.clientWidth) return;
        const next = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
        const changed = next !== this.index;
        this.index = next;
        this.pendingIndex = null;
        this.sync();
        if (changed && this.manualScroll) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
        this.manualScroll = false;
        this.schedule();
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artshop-idea-form"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('artshop-idea-form')) {
  class ArtshopIdeaForm extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.form = this.querySelector('form');
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.markers = [...this.querySelectorAll('[data-marker]')];
      this.file = this.form.elements.attachment;
      this.link = this.form.elements.Link_imagine;
      this.product = this.form.elements.Tip_produs;
      this.phone = this.form.elements.Telefon;
      this.help = this.form.elements.Ajutor_dimensiuni;
      this.method = this.form.elements.Contact_preferat;
      this.artShape = this.form.elements.Forma_tablou;
      this.artSize = this.form.elements.Dimensiune_tablou;
      this.artType = this.form.elements.Tip_tablou;
      this.frameColor = this.form.elements.Culoare_rama;
      this.customWidth = this.form.elements.Latime_personalizata_cm;
      this.customHeight = this.form.elements.Inaltime_personalizata_cm;
      this.next = this.querySelector('[data-next]');
      this.back = this.querySelector('[data-back]');
      this.send = this.querySelector('[data-submit]');
      this.errorBox = this.querySelector('.aif__error');
      this.status = this.querySelector('.aif__status');
      this.form.noValidate = true;
      this.index = 0;
      const listen = (target, type, handler) => target.addEventListener(type, handler, { signal: this.events.signal });
      listen(this.next, 'click', () => this.advance());
      listen(this.back, 'click', () => this.goTo(this.index - 1));
      [this.product, this.help, this.method, this.artSize, this.artType].forEach((field) => listen(field, 'change', () => this.updateFields()));
      listen(this.artShape, 'change', () => { this.rebuildArtSizes(); this.updateFields(); });
      listen(this.file, 'change', () => this.updateFile());
      listen(this.link, 'input', () => { this.file.setCustomValidity(''); this.link.setCustomValidity(''); this.clearError(); });
      listen(this.form, 'input', (event) => {
        const field = event.target;
        if (field.matches('input:not([type="file"]), select, textarea')) field.setCustomValidity('');
        if (field === this.customWidth || field === this.customHeight) this.customHeight.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      });
      listen(this.querySelector('[data-remove-file]'), 'click', () => { this.file.value = ''; this.updateFile(); });
      listen(this.form, 'submit', (event) => this.submit(event));
      this.rebuildArtSizes(true);
      this.updateFields();
      this.send.disabled = false;
      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      this.events = null;
    }

    clearError() { this.errorBox.hidden = true; this.errorBox.textContent = ''; }

    showError(message) { this.errorBox.textContent = message; this.errorBox.hidden = false; this.errorBox.focus(); }

    advance() {
      if (!this.busy && this.validateStep(this.flow[this.index])) this.goTo(this.index + 1);
    }

    goTo(index, focus = true) {
      this.index = Math.max(0, Math.min(this.flow.length - 1, index));
      const current = this.flow[this.index];
      this.clearError();
      this.style.setProperty('--aif-steps', this.flow.length);
      this.steps.forEach((step, rawIndex) => { step.hidden = rawIndex !== current; });
      this.markers.forEach((marker, rawIndex) => {
        const position = this.flow.indexOf(rawIndex);
        marker.hidden = position === -1;
        if (position !== -1) marker.querySelector('span').textContent = position + 1;
        if (rawIndex === current) marker.setAttribute('aria-current', 'step');
        else marker.removeAttribute('aria-current');
        marker.toggleAttribute('data-complete', position !== -1 && position < this.index);
      });
      this.querySelector('[data-contact-number]').textContent = this.flow.length;
      const last = this.index === this.flow.length - 1;
      this.back.hidden = this.index === 0;
      this.next.hidden = last;
      this.send.hidden = !last;
      if (focus) this.steps[current].querySelector('legend').focus();
    }

    toggleFields(selector, visible) {
      const group = this.querySelector(selector);
      group.hidden = !visible;
      group.querySelectorAll('input, select, textarea').forEach((field) => {
        field.disabled = !visible;
        field.required = visible;
        field.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      });
    }

    rebuildArtSizes(preserve = false) {
      const previous = preserve ? this.artSize.value : '';
      const shape = this.artShape.value;
      const sizes = shape === 'square' ? [[40, 40], [60, 60], [80, 80]] : [[30, 45], [40, 60], [50, 75], [60, 90]];
      this.artSize.replaceChildren(new Option(this.dataset.chooseSize, ''));
      if (!shape) return;
      for (const size of sizes) {
        const [width, height] = shape === 'horizontal' ? [size[1], size[0]] : size;
        this.artSize.add(new Option(`${width} × ${height} ${this.dataset.cm}`, `${width}x${height}`));
      }
      this.artSize.add(new Option(this.dataset.customSizeLabel, 'custom'));
      if ([...this.artSize.options].some((option) => option.value === previous)) this.artSize.value = previous;
    }

    updateFields() {
      const current = this.flow?.[this.index] ?? 0;
      const art = this.product.value === 'art';
      const clock = this.product.value === 'clock';
      this.flow = [0, 1, 2];
      this.toggleFields('[data-other]', this.product.value === 'other');
      this.toggleFields('[data-art-shape]', art);
      this.toggleFields('[data-art-size]', art && !!this.artShape.value && !this.help.checked);
      this.toggleFields('[data-art-custom]', art && !!this.artShape.value && this.artSize.value === 'custom' && !this.help.checked);
      this.toggleFields('[data-rectangle]', !art && !clock && !this.help.checked);
      this.toggleFields('[data-circle]', clock && !this.help.checked);
      const artOptionsVisible = art && !!this.artShape.value && (this.help.checked || !!this.artSize.value);
      this.toggleFields('[data-art-options]', artOptionsVisible);
      this.toggleFields('[data-frame-color]', artOptionsVisible && ['framed', 'glass_framed'].includes(this.artType.value));
      this.toggleFields('[data-email]', this.method.value === 'email');
      this.querySelector('[data-hint-general]').hidden = art || clock;
      this.querySelector('[data-hint-clock]').hidden = !clock;
      this.querySelector('[data-hint-art]').hidden = !art;
      this.querySelector('[data-help-message]').hidden = !this.help.checked;
      this.goTo(Math.max(0, this.flow.indexOf(current)), false);
    }

    fileError() {
      const file = this.file.files[0];
      if (!file) return '';
      const isVideo = /\.(mp4|mov|webm)$/i.test(file.name);
      const limit = (isVideo ? 20 : 10) * 1000 * 1000;
      if (file.size === 0 || file.size > limit) return this.dataset.fileError;
      const allowed = /\.(jpe?g|png|webp|gif|hei[cf]|tiff?|mp4|mov|webm)$/i.test(file.name);
      return allowed ? '' : this.dataset.fileTypeError;
    }

    updateFile() {
      this.file.setCustomValidity('');
      this.link.setCustomValidity('');
      this.clearError();
      const file = this.file.files[0];
      if (this.uploadCache?.file !== file) this.uploadCache = null;
      this.querySelector('.aif__file-detail').hidden = !file;
      this.querySelector('[data-file-name]').textContent = file ? `${file.name} · ${(file.size / 1000 / 1000).toFixed(1)} MB` : '';
      const error = this.fileError();
      if (error) { this.file.setCustomValidity(error); this.showError(error); }
    }

    validateStep(rawIndex) {
      if (rawIndex === 0) {
        this.file.setCustomValidity(this.fileError());
        this.link.setCustomValidity('');
        if (!this.file.files.length && !this.link.value.trim()) this.link.setCustomValidity(this.dataset.sourceError);
        if (this.link.value.trim()) {
          try {
            const url = new URL(this.link.value.trim());
            if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) throw new Error();
          } catch { this.link.setCustomValidity(this.dataset.urlError); }
        }
      }
      if (rawIndex === 1 && this.product.value === 'art' && this.artSize.value === 'custom' && !this.help.checked) {
        this.customHeight.setCustomValidity('');
        const width = this.customWidth.valueAsNumber;
        const height = this.customHeight.valueAsNumber;
        if (Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0) {
          const shape = this.artShape.value;
          const error = shape === 'vertical' && width >= height ? this.dataset.verticalError : shape === 'horizontal' && width <= height ? this.dataset.horizontalError : shape === 'square' && width !== height ? this.dataset.squareError : '';
          this.customHeight.setCustomValidity(error);
        }
      }
      if (rawIndex === 2) {
        const phone = this.phone.value.trim();
        const digits = phone.replace(/\D/g, '');
        this.phone.setCustomValidity(/^[+\d\s().-]+$/.test(phone) && digits.length >= 7 && digits.length <= 15 ? '' : this.dataset.phoneError);
      }
      const fields = [...this.steps[rawIndex].querySelectorAll('input, select, textarea')].filter((field) => !field.matches(':disabled'));
      for (const field of fields) {
        if (field.required && field.type === 'text') field.setCustomValidity(field.value.trim() ? '' : this.dataset.requiredError);
        if (!field.checkValidity()) {
          this.goTo(this.flow.indexOf(rawIndex), false);
          field.setAttribute('aria-invalid', 'true');
          field.focus();
          field.reportValidity();
          return false;
        }
      }
      return true;
    }

    buildSubmission() {
      const data = new FormData(this.form);
      data.delete('attachment');
      data.set('Produs', this.product.selectedOptions[0].textContent.trim());
      data.set('Contact_preferat', this.method.selectedOptions[0].textContent.trim());
      data.set('Ajutor_dimensiuni', this.help.checked ? this.dataset.yes : this.dataset.no);
      if (this.product.value === 'art') {
        data.set('Forma_tablou', this.artShape.selectedOptions[0].textContent.trim());
        data.set('Tip_tablou', this.artType.selectedOptions[0].textContent.trim());
        if (!this.frameColor.disabled) data.set('Culoare_rama', this.frameColor.selectedOptions[0].textContent.trim());
        if (!this.help.checked) {
          const [width, height] = this.artSize.value === 'custom' ? [this.customWidth.valueAsNumber, this.customHeight.valueAsNumber] : this.artSize.value.split('x').map(Number);
          data.set('Dimensiune_tablou', this.artSize.selectedOptions[0].textContent.trim());
          data.set('Latime_cm', String(width));
          data.set('Inaltime_cm', String(height));
        }
      }
      data.delete('Latime_personalizata_cm');
      data.delete('Inaltime_personalizata_cm');
      data.set('Pagina', location.origin + location.pathname);
      data.set('Limba', document.documentElement.lang);
      data.set('Cod_cerere', this.requestId || (this.requestId = crypto.randomUUID()));
      data.set('subject', `Artshop · ${this.product.selectedOptions[0].textContent.trim()} · ${data.get('Cod_cerere')}`);
      return data;
    }

    submissionError(result, status) {
      if (status === 429) return this.dataset.rateError;
      const errors = Array.isArray(result?.errors) ? result.errors : [];
      const codes = errors.map((error) => typeof error?.code === 'string' ? error.code.toUpperCase() : '');
      if (codes.includes('NO_FILE_UPLOADS')) return this.dataset.uploadsUnavailableError;
      if (codes.includes('FILES_TOO_BIG') || status === 413) return this.dataset.serviceFileSizeError;
      if (codes.some((code) => code.includes('CAPTCHA'))) return this.dataset.serviceCaptchaError;
      if (errors.some((error) => typeof error?.field === 'string' && error.field.toLowerCase() === 'email' && ['REQUIRED_FIELD_MISSING', 'REQUIRED_FIELD_EMPTY'].includes(String(error.code).toUpperCase()))) return this.dataset.serviceEmailRequiredError;
      if (codes.includes('TYPE_EMAIL')) return this.dataset.serviceEmailInvalidError;
      const messages = errors.map((error) => typeof error === 'string' ? error : error?.message).filter((message) => typeof message === 'string').slice(0, 3);
      if (!messages.length && typeof result?.error === 'string') messages.push(result.error);
      if (!messages.length && typeof result?.message === 'string') messages.push(result.message);
      const detail = messages.map((message) => message.replace(/\s+/g, ' ').trim()).filter(Boolean).join(' ').slice(0, 600);
      return detail ? `${this.dataset.serviceError} ${detail}` : this.dataset.sendError;
    }

    async fetchJson(url, options, timeoutMs) {
      const controller = this.request;
      const signal = controller.signal;
      const timeout = setTimeout(() => controller.abort(), timeoutMs);
      try {
        const response = await fetch(url, { ...options, signal, credentials: 'omit' });
        const result = await response.json().catch(() => null);
        return { response, result };
      } finally {
        clearTimeout(timeout);
      }
    }

    async uploadFile(file, cloudName, preset) {
      if (this.uploadCache?.file === file && this.uploadCache.cloudName === cloudName && this.uploadCache.preset === preset) return this.uploadCache;
      const body = new FormData();
      body.set('file', file);
      body.set('upload_preset', preset);
      const { response, result } = await this.fetchJson(`https://api.cloudinary.com/v1_1/${encodeURIComponent(cloudName)}/auto/upload`, { method: 'POST', body }, 120000);
      if (!response.ok) {
        const detail = typeof result?.error?.message === 'string' ? result.error.message.replace(/\s+/g, ' ').trim().slice(0, 300) : '';
        throw new Error(detail ? `${this.dataset.uploadError} ${detail}` : this.dataset.uploadError);
      }
      let url;
      try {
        url = new URL(result?.secure_url);
        if (url.protocol !== 'https:' || url.hostname !== 'res.cloudinary.com' || url.port || url.username || url.password || !['image', 'video'].includes(result?.resource_type) || !url.pathname.startsWith(`/${cloudName}/${result.resource_type}/upload/`)) throw new Error();
      } catch { throw new Error(this.dataset.uploadError); }
      this.uploadCache = { file, cloudName, preset, url: url.href };
      return this.uploadCache;
    }

    async submit(event) {
      event.preventDefault();
      if (this.busy || this.sent) return;
      if (this.index !== this.flow.length - 1) { this.advance(); return; }
      this.updateFields();
      for (const rawIndex of this.flow) if (!this.validateStep(rawIndex)) return;
      let endpoint;
      try {
        endpoint = new URL(this.dataset.endpoint);
        if (endpoint.origin !== 'https://formspree.io' || !/^\/f\/[a-zA-Z0-9]+\/?$/.test(endpoint.pathname) || endpoint.search || endpoint.hash || endpoint.username || endpoint.password) throw new Error();
      } catch { this.showError(this.dataset.configError); return; }
      const file = this.file.files[0];
      const cloudName = (this.dataset.cloudName || '').trim();
      const preset = (this.dataset.uploadPreset || '').trim();
      if (file && (!/^[a-zA-Z0-9_-]+$/.test(cloudName) || !preset)) { this.showError(this.dataset.uploadConfigError); return; }
      const data = this.buildSubmission();
      this.busy = true;
      this.form.setAttribute('aria-busy', 'true');
      const previousDisabled = this.steps.map((step) => step.disabled);
      this.steps.forEach((step) => { step.disabled = true; });
      const buttons = [...this.form.querySelectorAll('button')];
      buttons.forEach((button) => { button.disabled = true; });
      this.send.textContent = file ? this.dataset.uploadingLabel : this.dataset.sendingLabel;
      this.status.textContent = this.send.textContent;
      this.clearError();
      this.request = new AbortController();
      let confirmedFailure = false;
      let emailRequestStarted = false;
      try {
        if (file) {
          const upload = await this.uploadFile(file, cloudName, preset);
          data.set('Fisier_incarcat', upload.url);
          data.set('Nume_fisier', file.name);
          data.set('Marime_fisier_MB', (file.size / 1000 / 1000).toFixed(2));
        }
        if (!this.isConnected || this.request.signal.aborted) throw new Error(this.dataset.uploadError);
        this.send.textContent = this.dataset.sendingLabel;
        this.status.textContent = this.dataset.sendingLabel;
        emailRequestStarted = true;
        const { response, result } = await this.fetchJson(endpoint.href, { method: 'POST', body: JSON.stringify(Object.fromEntries(data)), headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }, 35000);
        if (!response.ok) {
          confirmedFailure = true;
          throw new Error(this.submissionError(result, response.status));
        }
        if (!result || result.ok !== true) throw new Error(this.dataset.uncertainError);
        this.sent = true;
        this.form.hidden = true;
        this.querySelector('.aif__progress').hidden = true;
        const success = this.querySelector('.aif__success');
        success.hidden = false;
        success.focus();
      } catch (error) {
        if (this.isConnected) this.showError(!emailRequestStarted ? (error.name === 'AbortError' || error instanceof TypeError ? this.dataset.uploadError : error.message) : confirmedFailure ? error.message : this.dataset.uncertainError);
      } finally {
        this.busy = false;
        this.form.removeAttribute('aria-busy');
        this.steps.forEach((step, index) => { step.disabled = previousDisabled[index]; });
        buttons.forEach((button) => { button.disabled = false; });
        this.send.textContent = this.dataset.sendLabel;
        this.status.textContent = '';
      }
    }
  }
  customElements.define('artshop-idea-form', ArtshopIdeaForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
var relatedProductsSection = document.querySelector(".related-products");

if (relatedProductsSection) {
  if ("IntersectionObserver" in window) {
    var relatedProductsObserver = new IntersectionObserver(function(entries, observer) {
      if (entries[0].isIntersecting) {
        observer.unobserve(relatedProductsSection);
        loadProductRecommendationsIntoSection();
      }
    }, { rootMargin: "600px 0px" });

    relatedProductsObserver.observe(relatedProductsSection);
  } else {
    loadProductRecommendationsIntoSection();
  }
}

  } catch(e) { console.error(e); }
})();
})();
